const initialState = {
  isLoading: false,
  data: [],
  catalog: {
    items: [],
    isLoading: false,
    error: null,
  },
  error: false,
  errorMessage: null,
  headers: null,
  errorCode: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_CATEGORIES': {
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    }
    case 'FAILED_GET_CATEGORIES': {
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload.data.message,
      };
    }
    case 'FINISH_GET_CATEGORIES': {
      return {
        ...state,
        isLoading: false,
        error: false,
        data: action.payload.data.categories,
        aiTag: action.payload.data.categories.ai_tag,
        headers: action.payload.data.meta,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'BEGIN_CREATE_CATEGORY': {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'FAILED_CREATE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload.response.data.error,
        errorCode: action.payload.response.status,
      };
    }
    case 'FINISH_CREATE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'BEGIN_DELETE_CATEGORY': {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'FAILED_DELETE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload.response.data.error,
        errorCode: action.payload.response.status,
      };
    }
    case 'FINISH_DELETE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'BEGIN_UPDATE_CATEGORY': {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'FAILED_UPDATE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: true,
        errorCode: action.payload.response.status,
      };
    }
    case 'FINISH_UPDATE_CATEGORY': {
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: null,
        errorCode: '',
      };
    }
    case 'BEGIN_GET_CATEGORY_CATALOG':
      return { ...state, catalog: { ...state.catalog, isLoading: true, error: null } };

    case 'FAILED_GET_CATEGORY_CATALOG':
      return {
        ...state,
        catalog: {
          ...state.catalog,
          isLoading: false,
          error: action.payload?.data?.message || 'Failed to load catalog',
        },
      };

    case 'FINISH_GET_CATEGORY_CATALOG':
      return {
        ...state,
        catalog: { items: action.payload.data.catalog, isLoading: false, error: null },
      };

    case 'FINISH_ENABLE_SUPPORTED_CATEGORY':
    case 'FINISH_DISABLE_SUPPORTED_CATEGORY': {
      const updatedDc = action.payload.data.category;
      const items = state.catalog.items.map((entry) => {
        if (entry.organization_state.document_category_id === updatedDc.id
          || entry.id === updatedDc.ai_supported_document_category_id) {
          return {
            ...entry,
            organization_state: {
              enabled: updatedDc.enabled,
              ever_used: updatedDc.ever_used,
              document_category_id: updatedDc.id,
              emr_category: updatedDc.emr_category,
              classification_hints: updatedDc.classification_hints || [],
              title_example: updatedDc.title_example || null,
              title_instruction: updatedDc.title_instruction || null,
              task_dedup_eligible: !!updatedDc.task_dedup_eligible,
            },
          };
        }
        return entry;
      });
      return { ...state, catalog: { ...state.catalog, items } };
    }

    case 'FAILED_ENABLE_SUPPORTED_CATEGORY':
    case 'FAILED_DISABLE_SUPPORTED_CATEGORY':
      return {
        ...state,
        catalog: {
          ...state.catalog,
          error: action.payload?.data?.message || 'Request failed',
        },
      };

    case 'FINISH_ADD_CATEGORY_HINT':
    case 'FINISH_REMOVE_CATEGORY_HINT': {
      const updatedDc = action.payload.data.category;
      const items = state.catalog.items.map((entry) => {
        if (entry.organization_state.document_category_id === updatedDc.id) {
          return {
            ...entry,
            organization_state: {
              ...entry.organization_state,
              classification_hints: updatedDc.classification_hints || [],
            },
          };
        }
        return entry;
      });
      return { ...state, catalog: { ...state.catalog, items } };
    }

    case 'FAILED_ADD_CATEGORY_HINT':
    case 'FAILED_REMOVE_CATEGORY_HINT':
      return {
        ...state,
        catalog: {
          ...state.catalog,
          error: action.payload?.response?.data?.error
            || action.payload?.data?.error
            || 'Hint request failed',
        },
      };

    case 'FINISH_SET_CATEGORY_TITLE_INSTRUCTION': {
      const updatedDc = action.payload.data.category;
      const items = state.catalog.items.map((entry) => {
        if (entry.organization_state.document_category_id === updatedDc.id) {
          return {
            ...entry,
            organization_state: {
              ...entry.organization_state,
              title_example: updatedDc.title_example || null,
              title_instruction: updatedDc.title_instruction || null,
            },
          };
        }
        return entry;
      });
      return { ...state, catalog: { ...state.catalog, items } };
    }

    case 'FAILED_SET_CATEGORY_TITLE_INSTRUCTION':
      return {
        ...state,
        catalog: {
          ...state.catalog,
          error: action.payload?.response?.data?.error
            || action.payload?.data?.error
            || 'Custom titling request failed',
        },
      };

    case 'FINISH_SET_CATEGORY_TITLE_OPTIONS': {
      const updatedDc = action.payload.data.category;
      const items = state.catalog.items.map((entry) => {
        if (entry.organization_state.document_category_id === updatedDc.id) {
          return {
            ...entry,
            organization_state: {
              ...entry.organization_state,
              title_options: updatedDc.title_options || [],
            },
          };
        }
        return entry;
      });
      return { ...state, catalog: { ...state.catalog, items } };
    }

    case 'FAILED_SET_CATEGORY_TITLE_OPTIONS':
      return {
        ...state,
        catalog: {
          ...state.catalog,
          error: action.payload?.response?.data?.error
            || action.payload?.data?.error
            || 'Title options request failed',
        },
      };

    default:
      return state;
  }
};
